module.exports = __webpack_public_path__ + "static/media/tile-price-3.180fe3af.jpg";